export default __webpack_public_path__ + "static/1-6c32297ced50ee925331175513909578.png";